import api from "../../api";
import axios from "../../utils/axios.instance";
import handleError from "../handle-error";

type getJobRequirementByIdParams = {
  jobRequirementId: string
  candidateId?: string
  jobId?: string
}

type getJobRequirementParams = {
  jobTitle?: string,
  isSharedToAllAgencies?: boolean
  onlyClosed?: boolean
}

export const getJobRequirement = async ({
  jobTitle,
  isSharedToAllAgencies,
  onlyClosed
}: getJobRequirementParams = {}) => {
  try {
    const params = new URLSearchParams()
    if (jobTitle) params.append('jobTitle', jobTitle?.toString())
    if (isSharedToAllAgencies) params.append('isSharedToAllAgencies', isSharedToAllAgencies?.toString())
    if (onlyClosed) params.append('onlyClosed', onlyClosed?.toString())
    const generalURL = api.jobRequirement.list
    const URL = params ? generalURL + `?${params?.toString()}` : generalURL
    const { data } = await axios.get(URL);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getMeetingRequirements = async ({
  jobRequirementId,
  candidateId,
  jobId
}: getJobRequirementByIdParams) => {
  try {
    const params = new URLSearchParams()
    if (candidateId !== undefined) params.append("candidateId", candidateId)
    if (jobId !== undefined) params.append("jobId", jobId)

    const generalURL = `${api.jobRequirement.byId}/${jobRequirementId}/team-members`
    const URL = params.toString() ? generalURL + `?${params?.toString()}` : generalURL

    const { data } = await axios.get(URL);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getJobRequirementById = async ({
  jobRequirementId,
}: getJobRequirementByIdParams) => {
  try {
    const URL = `${api.jobRequirement.byId}/${jobRequirementId}`
    const { data } = await axios.get(URL);
    return { ...data, data: data?.data[0] };
  } catch (err) {
    throw handleError(err);
  }
};

export const getRequirementByRecruiterId = async (recuiterId: string) => {
  try {
    const { data } = await axios.get(
      `${api.jobRequirement.byRecruiterId}?recruiterId=${recuiterId}&page=1&limit=10`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getAgentUserProfile = async (recuiterId: string) => {
  try {
    const { data } = await axios.post(
      `${api.jobRequirement.userProfile}?recruiterId=${recuiterId}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const addJobRequirement = async (payload) => {
  try {
    const { data } = await axios.post(api.jobRequirement.add, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateJobRequirement = async (payload) => {
  try {
    const { data } = await axios.patch(
      `${api.jobRequirement.update}/${payload?.id}`,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const addJobRequirementSkill = async (payload) => {
  try {
    const { data } = await axios.post(api.jobRequirement.skills.add, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const updateJobRequirementSkill = async (payload) => {
  try {
    const { data } = await axios.patch(
      `${api.jobRequirement.skills.update}/${payload?.id}`,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getSubmittedCandidates = async (jobRequirementId: string) => {
  try {
    const { data } = await axios.get(
      `${api.jobRequirement.list}/${jobRequirementId}${api.jobRequirement.submittedCandidates}`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const markReadyForHiring = async (jobRequirementId: string) => {
  try {
    const { data } = await axios.post(
      `${api.jobRequirement.byId}/${jobRequirementId}/ready-for-hiring`
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const getPartnerAgencies = async () => {
  try {
    const { data } = await axios.get(api.jobRequirement.partnerAgencies);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const grantAccess = async (payload) => {
  try {
    const { data } = await axios.post(api.jobRequirement.grantAccess, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const recruitersList = async (payload) => {
  try {
    let url = `${api.jobRequirement.recruitersAvailableToInvite}?page=${payload.page}&limit=${payload.limit}`;
    const { data } = await axios.post(url, payload);
    return data;
  } catch (err) {
    throw handleError(err);
  }
};

export const addRecruiterAsPartner = async (payload: {
  recruiterId: string;
}) => {
  try {
    const { data } = await axios.post(
      api.jobRequirement.sendPartnerRequest,
      payload
    );
    return data;
  } catch (err) {
    throw handleError(err);
  }
};
